import { render, staticRenderFns } from "./officialVehicle.vue?vue&type=template&id=64b057e8&scoped=true"
import script from "./officialVehicle.vue?vue&type=script&lang=js"
export * from "./officialVehicle.vue?vue&type=script&lang=js"
import style0 from "./officialVehicle.vue?vue&type=style&index=0&id=64b057e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_j7fuxwmg3pjjrof4ryv5g7uhre/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b057e8",
  null
  
)

export default component.exports